import React from 'react'
import SideBar from '../../components/commoncomponents/SideBar'
import Header from '../../components/commoncomponents/Header'
import Footer from '../../components/commoncomponents/Footer'
import { Layout, Content, ContentBody } from '../../assets/styled-components/layout'
import HospitalInformationList from '../../components/hospitalinformationcomponents/HospitalInfomationList'

function HospitalInformationDetails({renderPageContent}) {
    return (
        <>
                        {/*Dynamic content goes here */}
                        <HospitalInformationList renderPageContent={renderPageContent}/>
                       

        </>
    )
}

export default HospitalInformationDetails;